var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
// Material UI
import MuiDialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
// Say Lib
import Button from "../../Atoms/ButtonV2/ButtonV2";
import Text from "../../Atoms/Text";
// Utils
import { hyphenLowerCase } from "../../../utils/hyphenLowercase";
import { Box, Stack } from "@mui/material";
import { IconButton } from "../../Atoms";
/**
 * Dialog Title component
 */
var DialogTitle = function (props) {
    var children = props.children, hasIcon = props.hasIcon, onClose = props.onClose, other = __rest(props, ["children", "hasIcon", "onClose"]);
    return (_jsxs(Box, __assign({ sx: { margin: 0, p: 8, pt: hasIcon ? 4 : 8, pb: 0 } }, other, { children: [children, onClose ? (_jsx(IconButton, __assign({ "aria-label": "close", sx: {
                    right: function (theme) { return theme.spacing(3); },
                    top: function (theme) { return theme.spacing(3); },
                    position: "absolute",
                }, "data-testid": "dialog-close", onClick: onClose }, { children: _jsx(CloseIcon, {}) }))) : null] })));
};
var Dialog = function (_a) {
    var _b = _a.buttonActions, buttonActions = _b === void 0 ? [] : _b, title = _a.title, customTitle = _a.customTitle, _c = _a.ctaOrientation, ctaOrientation = _c === void 0 ? "vertical" : _c, content = _a.content, open = _a.open, _d = _a.titleTextVariant, titleTextVariant = _d === void 0 ? "subtitle1" : _d, handleClose = _a.handleClose, icon = _a.icon, _e = _a.dividers, dividers = _e === void 0 ? false : _e, _f = _a.fullBleed, fullBleed = _f === void 0 ? false : _f, customActionStyles = _a.customActionStyles, CustomWrapper = _a.CustomWrapper, rest = __rest(_a, ["buttonActions", "title", "customTitle", "ctaOrientation", "content", "open", "titleTextVariant", "handleClose", "icon", "dividers", "fullBleed", "customActionStyles", "CustomWrapper"]);
    var WrapperComponent = CustomWrapper || React.Fragment;
    var baseHorizontalActionStyles = __assign({ margin: 0, p: 8, pt: dividers ? 6 : 0, justifyContent: "flex-end", flexDirection: "row", gap: 3 }, customActionStyles);
    var baseVerticalActionStyles = __assign({ margin: 0, width: "100%", p: 8, pt: dividers ? 6 : 0, gap: 3, button: {
            width: "100%",
            ml: 0,
        } }, customActionStyles);
    // styles for action section
    var buttonActionStyles = ctaOrientation === "vertical"
        ? baseVerticalActionStyles
        : baseHorizontalActionStyles;
    var getTestId = function (str) {
        return "button-dialog-".concat(hyphenLowerCase(str));
    };
    /**
     * render action buttons
     */
    var getButtonActions = function () {
        if (buttonActions.length) {
            return (_jsx(MuiDialogActions, __assign({ "data-testid": "actions", sx: { p: 0 } }, { children: _jsx(Stack, __assign({ sx: buttonActionStyles }, { children: buttonActions.map(function (_a) {
                        var label = _a.label, itm = __rest(_a, ["label"]);
                        return (_jsx(Button, __assign({ "data-testid": getTestId(label) }, itm, { children: label }), label));
                    }) })) })));
        }
        return null;
    };
    return (_jsx(MuiDialog, __assign({ onClose: handleClose, "aria-labelledby": "customized-dialog-title", "data-testid": "custom-dialog", open: open }, rest, { slotProps: __assign(__assign({}, rest === null || rest === void 0 ? void 0 : rest.slotProps), { backdrop: {
                sx: { backgroundColor: "rgba(0,0,0,0.74)" },
            } }) }, { children: _jsxs(WrapperComponent, { children: [icon && (_jsx(Stack, __assign({ mt: 8, width: "100%", alignItems: "center", className: "dialog-icon" }, { children: icon }))), title ? (_jsx(DialogTitle, __assign({ id: "customized-dialog-title", onClose: handleClose, hasIcon: !!icon }, { children: _jsx(Text, __assign({ variant: titleTextVariant }, { children: title })) }))) : null, customTitle ? customTitle : null, content ? (_jsx(MuiDialogContent, __assign({ sx: {
                        px: fullBleed ? 0 : 8,
                        pt: fullBleed ? 0 : 4,
                        pb: fullBleed ? 0 : 6,
                        overflow: "visible",
                    }, dividers: dividers }, { children: content }))) : null, getButtonActions()] }) })));
};
export default Dialog;
